import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurvey.Step = React.createClass({
  onStepProgression: function() {
    if(this.props.currentStep.onSubmit) {
      this.props.currentStep.onSubmit(this.props.onStepProgression, this.props.onRequest, this.props.onRequestCompletion)
    }
  },

  onStepRetreat: function() {
    this.props.currentStep.onLeftNavButtonClick ? this.props.currentStep.onLeftNavButtonClick(this.props.onStepProgression, this.props.trigger) : this.props.onStepRetreat()
  },

  onModalExit: function() {
    var $jobClosureModal = $('#job-closure-modal')

    ClosureSurveyData.Actions.resetData()
    this.setState({currentStep: ClosureSurvey.Steps[0]})
    $jobClosureModal.modal('hide')
    $jobClosureModal.find('.modal-stay').trigger('click')
    ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.Steps[0])

    if (this.props.iosHref !== null && typeof this.props.iosHref !== "undefined") {
      window.location = this.props.iosHref
      SS.appFn.appMsg('Survey submitted')
    }
    else if (this.props.medium !== null && typeof this.props.medium !== "undefined" && this.props.medium == "android") {
      ClosureModal.postMessage('');
    }
    else {
      document.location.href =`/jobs/${this.props.jobId}`
    }
  },

  onSecondaryNavButtonClick: function() {
    this.props.currentStep.onSecondaryNavButtonClick ? this.props.currentStep.onSecondaryNavButtonClick() : null
  },

  componentWillEnter(callback) {
    const el = findDOMNode(this);
    TweenMax.fromTo(el, 0.3, {y: 100, opacity: 0}, {y: 0, opacity: 1, onComplete: callback});
  },

  navButtonLayout: function() {
    const buttonIdentifier = this.props.fromFastFeedback || this.props.trigger
    return this.props.currentStep.buttonLayout ? this.props.currentStep.buttonLayout(buttonIdentifier) : 'default'
  },

  render: function() {
    const ComponentClass = this.props.currentStep.component;

    return (
      <div className="closure-survey-modal-step">
        <div className="modal-body closure-survey-form-body pb0 pt0">
          <ComponentClass
            onStepProgression={this.onStepProgression}
            onRequest={this.props.onRequest}
            onRequestCompletion={this.props.onRequestCompletion}
            onStepRetreat={this.onStepRetreat}
            jobId={this.props.jobId}
            possibleBusinesses={this.props.possibleBusinesses}
            activeReasons={this.props.activeReasons}
            trigger={this.props.trigger}
            medium={this.props.medium}
            fromFastFeedback={this.props.fromFastFeedback}
            iosHref={this.props.iosHref}
            amountPaid={this.props.amountPaid}
          />
        </div>
        <div className="modal-footer pt30">
          <ClosureSurvey.NavigationButtons
            navButtonLayout={this.navButtonLayout()}
            buttons={this.props.currentStep.navigation} //overrides for button text etc
            onStepProgression={this.onStepProgression}
            onStepRetreat={this.onStepRetreat}
            onSecondaryNavButtonClick={this.onSecondaryNavButtonClick}
            onModalExit={this.onModalExit}
          />
        </div>
      </div>
    )
  }
})
